import { render } from "./sendOtp.vue?vue&type=template&id=53232127"
import script from "./sendOtp.vue?vue&type=script&lang=js"
export * from "./sendOtp.vue?vue&type=script&lang=js"

import "./sendOtp.vue?vue&type=style&index=0&id=53232127&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__